let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5houT")).then(() => parcelRequire('alwqL'));